import { ReactElement } from "react";
import { cn } from "@/lib/utils";

interface RadioInputBarProps {
  onSelect: () => void;
  leftContent: ReactElement | null;
  name: string;
  rightContent?: ReactElement | null;
  isSelected: boolean;
  className?: string;
  disabled?: boolean;
}

const RadioInputBar: React.FC<RadioInputBarProps> = ({
  onSelect,
  rightContent,
  leftContent,
  name,
  isSelected,
  className,
  disabled = false,
}) => {
  return (
    <div
      className={cn(
        "min-h-input relative flex w-full flex-row items-center justify-between space-x-2 px-4 shadow-xs ring-1",
        isSelected ? "z-10 ring-black" : "z-0 ring-gray-300",
        {
          "cursor-pointer": !disabled,
          "cursor-not-allowed": disabled,
        },
        className,
      )}
      onClick={disabled ? undefined : onSelect}
    >
      <div className="flex flex-row items-center space-x-2">
        <input
          id={name}
          name={name}
          type="radio"
          className={cn(
            "h-3 w-3",
            isSelected ? "text-black" : "text-gray-400",
            {
              "cursor-not-allowed opacity-50": disabled,
            },
          )}
          checked={isSelected}
          disabled={disabled}
          readOnly={!disabled}
        />
        <div className={cn("text-sm", { "opacity-50": disabled })}>
          {leftContent}
        </div>
      </div>
      <div className={cn({ "opacity-50": disabled })}>{rightContent}</div>
    </div>
  );
};

export default RadioInputBar;
